import React, { Fragment } from "react";
import ManagementBanner from "../Components/Management/ManagementBanner";
import { Helmet } from "react-helmet";

function Management() {
  const metaData = {
    title: 'Management | Salaam Takaful Management Structure',
    description: 'Learn about the management team at Salaam Takaful'
  }
  return (
    <Fragment>
      <Helmet>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
      </Helmet>
      <div className="container-fluid faderight ">
        <div className="row">
          <ManagementBanner />
        </div>
      </div>
    </Fragment>
  );
}

export default Management;
